import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const UserMyOrderDetail = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center w-100 justify-content-between">
										<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											Order ID: 0123546
										</h5>
										<h4 className="main-heading level-6 main-heading-font dark-color mb-0">
											Status: Pending
										</h4>
									</div>
								</div>
								<div className="row mb-4">
									<div className="col-lg-4">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<h4 className="primary-medium-font level-7 ">
												laudantium otam{" "}
											</h4>
											<h5 className="primary-medium-font level-8 extra-color-15">
												Qty: 05
											</h5>
										</div>
									</div>
									<div className="col-lg-4">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<h4 className="primary-medium-font level-7 ">
												laudantium otam{" "}
											</h4>
											<h5 className="primary-medium-font level-8 extra-color-15">
												Qty: 05
											</h5>
										</div>
									</div>
									<div className="col-lg-4">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<h4 className="primary-medium-font level-7 ">
												laudantium otam{" "}
											</h4>
											<h5 className="primary-medium-font level-8 extra-color-15">
												Qty: 05
											</h5>
										</div>
									</div>
								</div>
								<div className="row border-top pt-4 border-bottom pb-4">
									<div className="col-lg-12">
										<div className="order-detail-content">
											<div className="row">
												<div className="col-lg-4">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Pharmacy Name:
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															ABC Pharmacy
														</h5>
													</div>
												</div>
												<div className="col-lg-4">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Pharmacy Contact:
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															+00 123 456 789
														</h5>
													</div>
												</div>
												<div className="col-lg-4">
													<div className="details-pharmacy extra-bg-14 radius-40 p-2 text-center">
														<h4 className="main-heading-font level-6 mb-0">
															Delivery Type: Pickup
														</h4>
													</div>
												</div>
												<div className="col-lg-12 mt-4">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Pharmacy Address:
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															Shop# 1032, Lorem ipsum, dummy address, Unknown
															street, 30 block, USA
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="billing-detail">
									<h4 class="main-heading-font level-6 mt-4">
										Billing Details:
									</h4>
									<div className="row mt-3">
										<div className="col-lg-4 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												First Name: John
											</h4>
										</div>
										<div className="col-lg-4 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												Last Name: Doe
											</h4>
										</div>
										<div className="col-lg-4"></div>
										<div className="col-lg-4 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												Email: johndoe@email.com
											</h4>
										</div>
										<div className="col-lg-4 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												Phone: +00 123 456 789
											</h4>
										</div>
										<div className="col-lg-4"></div>
										<div className="col-lg-12 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												Address: Shop# 1032, Lorem ipsum, dummy address, Unknown
												street, 30 block, USA
											</h4>
										</div>
										<div className="col-lg-3 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												City: Baltimore
											</h4>
										</div>
										<div className="col-lg-3 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												State: Maryland
											</h4>
										</div>
										<div className="col-lg-3 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												Country: USA
											</h4>
										</div>
										<div className="col-lg-3 mb-2">
											<h4 className="primary-medium-font level-8 extra-color-10">
												Zip Code: 2371
											</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserMyOrderDetail;
